
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/selling-offers/[[...params]]",
      function () {
        return require("private-next-pages/selling-offers/[[...params]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/selling-offers/[[...params]]"])
      });
    }
  